<div id="accordionGeneralData" [formGroup]="generalDataForm">
  <dq-accordion
    id="puntodeventa"
    icon="icon-denominacion.svg"
    label="Punto de venta"
  >
    <div class="card-body px-0">
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-3">
              <label for="">{{ "pos.id" | translate }}</label>

              <p>{{ posSelected.id }}</p>
            </div>

            <div class="col-md-3">
              <label for="">{{ "pos.comercialName" | translate }}</label>
              <input
                type="text"
                formControlName="commercialName"
                *ngIf="editMode"
              />
              <small
                class="form-text text-danger"
                *ngIf="
                  editMode &&
                  generalDataForm.get('commercialName')?.errors?.required
                "
              >
                {{ "validations.required" | translate }}<br
              /></small>

              <p *ngIf="!editMode">{{ posSelected.commercialName }}</p>
            </div>

            <div class="col-md-3">
              <label for="">{{ "pos.fiscalName" | translate }}</label>

              <p>{{ posSelected.fiscalName }}</p>
            </div>

            <div class="col-md-3">
              <label for="">{{ "pos.type" | translate }}</label>
              <p *ngIf="!editMode">{{ posSelected.typePosDescription }}</p>
              <select
                formControlName="typePos"
                class="form-control input-group flex-nowrap input-group-sm"
                *ngIf="editMode"
              >
                <option *ngFor="let aux of posTypes" [value]="aux.id">
                  {{ aux.name }}
                </option>
              </select>
              <small
                class="form-text text-danger"
                *ngIf="
                  editMode && generalDataForm.get('typePos')?.errors?.required
                "
              >
                {{ "validations.required" | translate }}<br
              /></small>
            </div>
          </div>
        </li>

        <li class="list-group-item">
          <div class="row">
            <div class="col-md-3">
              <label for=""> {{ "pos.tam" | translate }} </label>
              <p>{{ posSelected.nameTam }}</p>
            </div>

            <div class="col-md-3">
              <label for=""> {{ "pos.rdc" | translate }} </label>
              <p>{{ posSelected.nameRDC }}</p>
            </div>

            <div class="col-md-3">
              <label for=""> {{ "pos.is" | translate }} </label>
              <p>{{ posSelected.internalSales }}</p>
            </div>

            <div class="col-md-3">
              <label for=""> {{ "pos.keyAccount" | translate }} </label>
              <p>-</p>
            </div>
          </div>
        </li>
      </ul>

      <div class="card-body subtitle">
        <h5 class="card-title">
          <img src="assets/img/icon-horario.svg" alt="Horario" class="mr-2" />
          {{ "pos.schedule" | translate }}
        </h5>
      </div>

      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-3">
              <label for="">{{ "pos.morningSchedule" | translate }} </label>
              <p *ngIf="!editMode">
                {{
                  posSelected.morningOpeningTime
                    ? posSelected.morningOpeningTime
                    : "-"
                }}
                /
                {{
                  posSelected.morningClosingTime
                    ? posSelected.morningClosingTime
                    : "-"
                }}
              </p>
              <div *ngIf="editMode" class="form-inline">
                <input
                  type="text"
                  formControlName="morningOpeningTime"
                  *ngIf="editMode"
                  style="width: 75px"
                />
                /
                <input
                  type="text"
                  formControlName="morningClosingTime"
                  *ngIf="editMode"
                  style="width: 75px"
                />
              </div>
              <small
                class="form-text text-danger"
                *ngIf="
                  (editMode &&
                    generalDataForm.get('morningOpeningTime')?.errors
                      ?.pattern) ||
                  generalDataForm.get('morningClosingTime')?.errors?.pattern
                "
              >
                {{ "validations.hourFormat" | translate }}<br
              /></small>
            </div>

            <div class="col-md-3">
              <label for="">{{ "pos.afternoonSchedule" | translate }} </label>
              <p *ngIf="!editMode">
                {{
                  posSelected.afternoonOpeningTime
                    ? posSelected.afternoonOpeningTime
                    : "-"
                }}
                &nbsp; / &nbsp;
                {{
                  posSelected.afternoonClosingTime
                    ? posSelected.afternoonClosingTime
                    : "-"
                }}
              </p>
              <div *ngIf="editMode" class="form-inline">
                <input
                  type="text"
                  formControlName="afternoonOpeningTime"
                  *ngIf="editMode"
                  style="width: 75px"
                />
                &nbsp;/&nbsp;
                <input
                  type="text"
                  formControlName="afternoonClosingTime"
                  *ngIf="editMode"
                  style="width: 75px"
                />
              </div>
              <small
                class="form-text text-danger"
                *ngIf="
                  (editMode &&
                    generalDataForm.get('afternoonOpeningTime')?.errors
                      ?.pattern) ||
                  generalDataForm.get('afternoonClosingTime')?.errors?.pattern
                "
              >
                {{ "validations.hourFormat" | translate }}
              </small>
            </div>
            <!--
            <div class="col-md-6">
              <label for="">{{ "pos.callTime" | translate }} </label>
              <p *ngIf="!editMode">
                {{
                  posSelected.preferredTimeCall
                    ? posSelected.preferredTimeCall
                    : "-"
                }}
              </p>

              <select
                formControlName="preferredTimeCall"
                class="form-control input-group flex-nowrap input-group-sm"
                *ngIf="editMode"
              >
                <option *ngFor="let aux of preferredsCallTime" [value]="aux.id">
                  {{ aux.name }}
                </option>
              </select>
              <small
                class="form-text text-danger"
                *ngIf="
                  (editMode &&
                    generalDataForm.get('preferredTimeCall')?.errors
                      ?.pattern) ||
                  generalDataForm.get('preferredTimeCall')?.errors?.pattern
                "
              >
                {{ "validations.required | translate }}
              </small>
            </div>-->
          </div>
        </li>

        <li class="list-group-item">
          <div class="row">
            <div class="col-md-12">
              <label for="">{{ "pos.otherInformation" | translate }} </label>
              <p *ngIf="!editMode">
                {{
                  posSelected.openingAdditionalInfo
                    ? posSelected.openingAdditionalInfo
                    : "-"
                }}
              </p>
              <input
                type="text"
                formControlName="openingAdditionalInfo"
                *ngIf="editMode"
              />
            </div>
          </div>
        </li>
      </ul>

      <div class="card-body subtitle">
        <h5 class="card-title">
          <img src="assets/img/icon-info.svg" alt="Horario" class="mr-2" />{{
            "pos.contactInformation" | translate
          }}
        </h5>
      </div>

      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <div class="row">
            <div class="col-xl-3 col-lg-3">
              <label for="">
                {{ "pos.phone" | translate }}
                <a class="px-2 d-inline" (click)="addPhone()" *ngIf="editMode"
                  ><img src="assets/img/icon-plus.svg"
                /></a>
              </label>
              <p *ngIf="!editMode">
                <i
                  *ngIf="posSelected.phone1Print == 'X'"
                  class="fa fa-check"
                  aria-hidden="true"
                ></i>
                {{ posSelected.phone1 ? posSelected.phone1 : "-" }}
                <i
                  *ngIf="posSelected.phone2Print == 'X'"
                  class="fa fa-check"
                  aria-hidden="true"
                ></i>
                {{
                  posSelected.phone2 != null && posSelected.phone2 != ""
                    ? ", " + posSelected.phone2
                    : ""
                }}
                <i
                  *ngIf="posSelected.phone3Print == 'X'"
                  class="fa fa-check"
                  aria-hidden="true"
                ></i>
                {{
                  posSelected.phone3 != null && posSelected.phone3 != ""
                    ? ", " + posSelected.phone3
                    : ""
                }}
              </p>

              <div *ngIf="editMode && numberOfPhones > 0">
                <!-- modo edición -->
                <div class="form-check form-check-inline">
                  <input
                    type="checkbox"
                    style="width: 20px !important; margin-right: 5px"
                    formControlName="phone1Print"
                    ng-true-value="X"
                    ng-false-value=""
                  />
                  <input type="text" class="w-90" formControlName="phone1" />
                  <a
                    class="px-2 d-inline"
                    (click)="removePhone()"
                    *ngIf="editMode"
                    ><img src="assets/img/minus.png"
                  /></a>
                </div>
                <small
                  class="form-text text-danger"
                  *ngIf="
                    (editMode &&
                      generalDataForm.get('phone1')?.errors?.pattern) ||
                    generalDataForm.get('phone1')?.errors?.pattern
                  "
                >
                  {{ "validations.formatPhone" | translate }}
                </small>
              </div>
              <div *ngIf="editMode && numberOfPhones > 1">
                <!-- modo edición -->
                <div class="form-check form-check-inline">
                  <input
                    type="checkbox"
                    style="width: 20px !important; margin-right: 5px"
                    formControlName="phone2Print"
                    ng-true-value="X"
                    ng-false-value=""
                  />
                  <input type="text" class="w-90" formControlName="phone2" />
                  <a
                    class="px-2 d-inline"
                    (click)="removePhone()"
                    *ngIf="editMode"
                    ><img src="assets/img/minus.png"
                  /></a>
                </div>
                <small
                  class="form-text text-danger"
                  *ngIf="
                    (editMode &&
                      generalDataForm.get('phone2')?.errors?.pattern) ||
                    generalDataForm.get('phone2')?.errors?.pattern
                  "
                >
                  {{ "validations.formatPhone" | translate }}
                </small>
              </div>
              <div *ngIf="editMode && numberOfPhones > 2">
                <!-- modo edición -->
                <div class="form-check form-check-inline">
                  <input
                    type="checkbox"
                    style="width: 20px !important; margin-right: 5px"
                    formControlName="phone3Print"
                    ng-true-value="X"
                    ng-false-value=""
                  />
                  <input type="text" class="w-90" formControlName="phone3" />
                  <a
                    class="px-2 d-inline"
                    (click)="removePhone()"
                    *ngIf="editMode"
                    ><img src="assets/img/minus.png"
                  /></a>
                  <small
                    class="form-text text-danger"
                    *ngIf="
                      (editMode &&
                        generalDataForm.get('phone3')?.errors?.pattern) ||
                      generalDataForm.get('phone3')?.errors?.pattern
                    "
                  >
                    {{ "validations.formatPhone" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-lg-3">
              <label for=""
                >{{ "pos.email" | translate }}
                <a class="px-2 d-inline" (click)="addMail()" *ngIf="editMode"
                  ><img src="assets/img/icon-plus.svg"
                /></a>
              </label>
              <p *ngIf="!editMode">
                <i
                  *ngIf="posSelected.email1Print == 'X'"
                  class="fa fa-check"
                  aria-hidden="true"
                ></i>

                {{ posSelected.email1 ? posSelected.email1 : "-" }}
                <i
                  *ngIf="posSelected.email2Print == 'X'"
                  class="fa fa-check"
                  aria-hidden="true"
                ></i>
                {{
                  posSelected.email2 != null && posSelected.email2 != ""
                    ? ", " + posSelected.email2
                    : ""
                }}
                <i
                  *ngIf="posSelected.email3Print == 'X'"
                  class="fa fa-check"
                  aria-hidden="true"
                ></i>
                {{
                  posSelected.email3 != null && posSelected.email3 != ""
                    ? ", " + posSelected.email3
                    : ""
                }}
              </p>

              <div *ngIf="editMode && numberOfMails > 0">
                <div class="form-check form-check-inline">
                  <input
                    type="checkbox"
                    style="width: 20px !important; margin-right: 5px"
                    formControlName="email1Print"
                    ng-true-value="X"
                    ng-false-value=""
                  />
                  <!-- modo edición -->
                  <input
                    type="text"
                    class="w-90"
                    formControlName="email1"
                    email="true"
                  />
                  <a
                    class="px-2 d-inline"
                    (click)="removeMail()"
                    *ngIf="editMode"
                    ><img src="assets/img/minus.png"
                  /></a>
                </div>

                <small
                  class="form-text text-danger"
                  *ngIf="
                    (editMode &&
                      generalDataForm.get('email1')?.errors?.required) ||
                    generalDataForm.get('email1')?.errors?.email
                  "
                >
                  {{ "validations.formatEmail" | translate }}
                </small>
              </div>
              <div *ngIf="editMode && numberOfMails > 1">
                <!-- modo edición -->
                <div class="form-check form-check-inline">
                  <input
                    type="checkbox"
                    style="width: 20px !important; margin-right: 5px"
                    formControlName="email2Print"
                    ng-true-value="X"
                    ng-false-value=""
                  />
                  <input
                    type="text"
                    class="w-90"
                    formControlName="email2"
                    email="true"
                  />
                  <a
                    class="px-2 d-inline"
                    (click)="removeMail()"
                    *ngIf="editMode"
                    ><img src="assets/img/minus.png"
                  /></a>
                </div>
                <small
                  class="form-text text-danger"
                  *ngIf="
                    (editMode &&
                      generalDataForm.get('email2')?.errors?.required) ||
                    generalDataForm.get('email2')?.errors?.email
                  "
                >
                  {{ "validations.formatEmail" | translate }}
                </small>
              </div>
              <div *ngIf="editMode && numberOfMails > 2">
                <!-- modo edición -->
                <div class="form-check form-check-inline">
                  <input
                    type="checkbox"
                    style="width: 20px !important; margin-right: 5px"
                    formControlName="email3Print"
                    ng-true-value="X"
                    ng-false-value=""
                  />
                  <input
                    type="text"
                    class="w-90"
                    formControlName="email3"
                    email="true"
                  />
                  <a
                    class="px-2 d-inline"
                    (click)="removeMail()"
                    *ngIf="editMode"
                    ><img src="assets/img/minus.png"
                  /></a>
                </div>
                <small
                  class="form-text text-danger"
                  *ngIf="
                    (editMode &&
                      generalDataForm.get('email3')?.errors?.required) ||
                    generalDataForm.get('email3')?.errors?.email
                  "
                >
                  {{ "validations.formatEmail" | translate }}
                </small>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6">
              <label for="">{{ "pos.webSite" | translate }} </label>
              <p>{{ posSelected.website ? posSelected.website : "-" }}</p>
            </div>
          </div>
        </li>
      </ul>
      <div class="card-body subtitle">
        <h5 class="card-title">
          <img src="assets/img/icon-horario.svg" alt="Horario" class="mr-2" />
          {{ "pos.status_info" | translate }}
        </h5>
      </div>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-3">
              <label for="">{{ "pos.status" | translate }}</label>
              <p *ngIf="!editMode">
                {{ getStatusCode(posSelected.status) | translate }}
              </p>
              <select
                formControlName="status"
                class="form-control input-group flex-nowrap input-group-sm"
                *ngIf="editMode"
              >
                <option value="NULL">{{ "status.NULL" | translate }}</option>
                <option value="A">{{ "status.a" | translate }}</option>
                <option value="B">{{ "status.b" | translate }}</option>
                <option value="C">{{ "status.c" | translate }}</option>
                <option value="D">{{ "status.d" | translate }}</option>
                <option value="I">{{ "status.i" | translate }}</option>
                <option value="P">{{ "status.p" | translate }}</option>
                <option value="ZT">{{ "status.zt" | translate }}</option>
              </select>
              <small
                class="form-text text-danger"
                *ngIf="
                  editMode && generalDataForm.get('status')?.errors?.required
                "
              >
                {{ "validations.required" | translate }}<br
              /></small>
            </div>

            <div class="col-md-3">
              <label for="">{{ "pos.notVisible" | translate }}</label>
              <i
                *ngIf="!editMode && posSelected.notVisible == 'X'"
                class="fa fa-check"
                aria-hidden="true"
              ></i>
              <p *ngIf="!editMode && posSelected.notVisible != 'X'">-</p>

              <input
                type="checkbox"
                formControlName="notVisible"
                *ngIf="editMode"
                style="text-align: left; width: auto !important"
                ng-true-value="X"
                ng-false-value=""
              />
              <small
                class="form-text text-danger"
                *ngIf="
                  editMode &&
                  generalDataForm.get('notVisible')?.errors?.required
                "
              >
                {{ "validations.required" | translate }}<br
              /></small>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </dq-accordion>
</div>
